/**
 * Shared outline button styles for Dolben CTAs.
 *
 * Light surfaces: black text/border, transparent fill → secondary fill + white text on hover.
 * Dark surfaces: white text/border, transparent fill → secondary fill + white text on hover.
 */

/** Outline CTA on light / background surfaces */
export const btnOnLight =
  'bg-transparent text-foreground border border-foreground transition-colors duration-300 hover:bg-secondary hover:text-secondary-foreground hover:border-secondary';

/** Outline CTA on dark / primary / image surfaces */
export const btnOnDark =
  'bg-transparent text-primary-foreground border border-primary-foreground transition-colors duration-300 hover:bg-secondary hover:text-secondary-foreground hover:border-secondary';
